import { useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../../../../../_augmentt/selectors/customers'
import useAuthorization from '../../../../hooks/useAuthorization'
import { DefaultSettingsContext } from './DefaultSettingsProvider'

const EMPTY_SETTINGS = {} // if no setting return empty object with same reference always (important for hooks dependency arrays)

/**
 * Returns the default settings for the selected customer given an action (defined in DEFAULT_SETTINGS_ACTIONS)
 * If setting for a customer is not present will return the global settings for that action or empty object
 * NOTE: depends on being on the DefaultSettingsContext subtree
 */
const useDefaultSettings = ({ action }) => {
  const { engageDefaultSettings } = useContext(DefaultSettingsContext)

  const selectedCustomerId = useSelector(getSelectedCustomerId)

  const { isAuthorizedForEngageAutopilot } = useAuthorization()

  const result = useMemo(() => {
    if (!isAuthorizedForEngageAutopilot) {
      console.warn('useDefaultSettings: company is not authorized for engage autopilot')
      return null
    }

    if (!action || !selectedCustomerId) {
      console.error('useDefaultSettings: action and selectedCustomerId are required for this hook')
      return null
    }

    const customerSettings = engageDefaultSettings?.find(
      (item) => item.action === action && item.customerId === selectedCustomerId,
    )
    if (customerSettings) {
      return customerSettings
    }

    return engageDefaultSettings?.find((item) => item.action === action && item.customerId === null)
  }, [action, selectedCustomerId, engageDefaultSettings, isAuthorizedForEngageAutopilot])

  return result?.settings || EMPTY_SETTINGS
}

export default useDefaultSettings
